export default "__VITE_ASSET__Hnn3DMIb__"